import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "components/ui";
import React, { Fragment, useEffect, useState } from "react";
import MuiBox from "../MuiBox";

const CustomSelect = ({
  label,
  val,
  onChange,
  error,
  errorMsg,
  options,
  placeholder,
  className,
}) => {
  const [selectedVal, setSelectedVal] = useState();

  useEffect(() => {
    setSelectedVal(val);
  }, [val]);

  return (
    <MuiBox>
      <span>{label}</span>
      <Select
        value={selectedVal}
        indicatorPosition="right"
        indicatorVisibility={null}
        indicator={<></>}
        onValueChange={(value) => {
          setSelectedVal(value);
          onChange(value);
          // handleSelect(Number(value));
        }}
      >
        <SelectTrigger
          className={`w-[200px] h-10 px-4 text-[14px] size="md" ${
            !selectedVal ? "text-muted-foreground" : "text-foreground"
          } ${className} ${error ? "border-red-500" : ""}`}
        >
          <SelectValue placeholder={selectedVal ? selectedVal : placeholder} />
        </SelectTrigger>
        <SelectContent
          position="popper"
          side="bottom"
          className={"z-[9999] min-w-[200px]"}
        >
          {options?.map((item) => (
            <SelectItem key={item?.value} value={item?.value}>
              {item?.label}
            </SelectItem>
          ))}
        </SelectContent>
        {error ? (
          <div className="text-[0.8125rem] text-red-500 ">{errorMsg}</div>
        ) : null}
      </Select>
    </MuiBox>
  );
};

export default CustomSelect;
